import { FileKind } from "../../../define/FileKind";
import { BaseLocalListData } from "../base/BaseLocalListData";


/** 数据 */
export class ThruTimeLevelData{
    /** id */
    id: string = '';
    /** 是否已经开启 */
    bOpen: boolean = false;
    /** 是否第一次过关 */
    bFirstWin: boolean = true;
}

export default class ThruTimeData extends BaseLocalListData {
    lists = new Map<string, ThruTimeLevelData>();

    /** 当前选择的关卡 */
    curSelectLv: string = null;
    /** 版本号 */
    curVersion: number = 0;
   
    protected localKey: string = FileKind.SaveLocalDataKey.THRU_TIME_DATA;

    createItem(key: string): ThruTimeLevelData {
        return this.createItemT<ThruTimeLevelData>(ThruTimeLevelData, key);
    }
   
}
